import { Button, Color, UIRenderer, _decorator } from 'cc';
import ButtonStateEffect from './ButtonStateEffect';

const { ccclass, property, requireComponent, menu } = _decorator;

@ccclass('ButtonColorEffect')
@requireComponent(UIRenderer)
@menu('ButtonStateEffect/ButtonColorEffect')
export default class ButtonColorEffect extends ButtonStateEffect<UIRenderer> {
    @property({ formerlySerializedAs: 'normalColor' })
    private _normalColor = Color.WHITE.clone();

    @property({ formerlySerializedAs: 'pressedColor' })
    private _pressedColor = Color.WHITE.clone();

    @property({ formerlySerializedAs: 'hoverColor' })
    private _hoverColor = Color.WHITE.clone();

    @property({ formerlySerializedAs: 'disabledColor' })
    private _disabledColor = Color.WHITE.clone();

    @property
    public get normalColor() {
        return this._normalColor;
    }
    public set normalColor(value: Color) {
        if (value.equals(this._normalColor)) {
            return;
        }
        this._normalColor = value;
        this.syncState();
    }

    @property
    public get pressedColor() {
        return this._pressedColor;
    }
    public set pressedColor(value: Color) {
        if (value.equals(this._pressedColor)) {
            return;
        }
        this._pressedColor = value;
        this.syncState();
    }

    @property
    public get hoverColor() {
        return this._hoverColor;
    }
    public set hoverColor(value: Color) {
        if (value.equals(this._hoverColor)) {
            return;
        }
        this._hoverColor = value;
        this.syncState();
    }

    @property
    public get disabledColor() {
        return this._disabledColor;
    }
    public set disabledColor(value: Color) {
        if (value.equals(this._disabledColor)) {
            return;
        }
        this._disabledColor = value;
        this.syncState();
    }

    protected getEffectTarget() {
        return this.getComponent(UIRenderer);
    }

    protected updateState(state: Button.State) {
        const colorMap: { [state in Button.State]: Color } = {
            [Button.State.NORMAL]: this.normalColor,
            [Button.State.PRESSED]: this.pressedColor,
            [Button.State.HOVER]: this.hoverColor ?? this.normalColor,
            [Button.State.DISABLED]: this.disabledColor,
        };
        this.effectTarget.color = colorMap[state];
    }
}
